<template src="./DistanceTravelReport.html"></template>
<script>
import { orderBy } from "@progress/kendo-data-query";
import { saveExcel } from "@progress/kendo-vue-excel-export";
// import CommandCell from "@/components/CommandCellTemplate/CommandCellTemplate";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapGetters, mapActions, mapMutations } = createNamespacedHelpers("reports");
import { MESSAGES } from "@/utils/constants";
import { notify, notifyApiError, notifyError } from "@/utils/notification-helper";
// import EmployeeCell from "@/components/EmployeeImageCell";
// import vendorService from "@/api/vendorService";
// const apiMethods = require("./../../../../api/api")
import DialogBox from "@/components/DialogBox";
import ViewDropdown from "@/components/ViewDropdown";
import { LOCAL_STORAGE_KEYS } from "@/utils/constants";
import moment from "moment-timezone";
// import Address from "@/views/Driver/Address";
import AddressCell from "@/components/AddressCell";
import EmployeeErrors from "@/components/EmployeeError";
import $ from "jquery";
export default {
  components: {
    DialogBox,
    ViewDropdown,
    AddressCell,
    EmployeeErrors,
  },
  data: function () {
    return {
      gridHeight: window.innerHeight - 200,
      // addoredit: false,
      gridData: [],
      searchText: "",
      skip: 0,
      take: 25,
      pageSize: 25,
      pageable: {
        previousNext: true,
        pageSizes: [5, 10, 25, 100, 500],
        pageSize: 10,
      },
      add: true,
      sort: [{ field: "name", dir: "asc" }],
      filteredColumns: [],
      columns: [
        {
          hidden: false,
          field: "DateString",
          title: "Date",
          width: "100px",
          checked: true,
          defaultSelected: true,
        },
        {
          hidden: false,
          title: "RTO Number",
          field: "RTONumber",
          width: "120px",
          checked: true,
          defaultSelected: true,
        },
        {
          hidden: false,
          field: "StartOdo",
          title: "Start Odo Meter",
          width: "130px",
          checked: true,
          defaultSelected: true,
        },
        {
          hidden: false,
          field: "EndOdo",
          title: "End Odo Meter",
          width: "120px",
          checked: true,
          defaultSelected: true,
        },        
        {
          hidden: false,
          field: "Distance",
          title: "Distance(Km)",
          width: "130px",
          checked: true,
          defaultSelected: true,
        },
      ],
      dataItems: [],
      fromTime: new Date(new Date().setHours("00", "00", "00", "000")),
      toTime: new Date(new Date().setHours("23", "59", "59", "999")),
      searchingVehicleRtoNumber: null,
      vehicleSearchFilter: "",
    };
  },
  methods: {
    ...mapActions(["fetchDistanceTravelledReport", "loadVehicles"]),
    ...mapMutations(["setDistanceTravelledReport", "setLoaderStatus"]),
    sortChangeHandler: function (e) {
      this.sort = e.sort;
    },
    showErrors: function () {
      this.$refs.rosterErros.show();
    },
    uploadTemplate(e) {
      this.$store.dispatch("driver/uploadTemplate", e);
      this.$refs.templateUpload.value = "";
    },
    pageChangeHandler: function (event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    showAdd: function () {
      this.add = true;
    },
    goToAddPage: function () {
      this.$router.push({ name: "driverAddUpdate", params: { add: true } });
    },
    remove: function (item) {
      this.dataItems = item;
      this.$refs.form.openWindow();
    },
    OkMethod() {
      let item = this.dataItems;
      return this.$store
        .dispatch("driver/removeDriver", item)
        .then(() => {
          notify(MESSAGES.DELETE_SUCCESS);
        })
        .catch(notifyApiError);
    },
    edit: function (item) {
      return this.$store.dispatch("driver/editDriver", item.dataItem); //item.dataItem.id
    },
    async getDataOnload() {
      this.setDistanceTravelledReport([]);
    },
    columnChange: function (e) {
      if (e.item.checked) {
        e.item.hidden = false;
      } else {
        e.item.hidden = true;
      }
      localStorage.setItem(
        LOCAL_STORAGE_KEYS.DRIVER_MANAGEMENT,
        JSON.stringify(this.filteredColumns)
      );
    },
    exportExcel() {
      saveExcel({
        data: this.getDistanceTravelledReport,
        fileName: "Distance Travelled Report",
        columns: this.columns,
      });
    },
    downloadTemplate() {
      this.$store.dispatch("driver/DownloadTemp");
      //    saveExcel({
      //   data:  [],
      //   fileName: "driverTemplate",
      //   columns:this.columns
      // });
    },
    getDate: function (h, tdElement, props) {
      let date = props.dataItem[props.field];
      if (date) {
        if (date.charAt(date.length - 1) === "Z") {
          date = moment(date).format("MM/DD/YYYY");
        } else {
          date = moment(date + "Z").format("MM/DD/YYYY");
        }
      }
      return h("td", {}, date ? date.toString() : "");
    },
    searchDistanceTravelReport() {
      if (!this.fromTime) {
        notifyError(MESSAGES.INVALID_DATE);
        return false;
      }
      if (!this.toTime) {
        notifyError(MESSAGES.INVALID_DATE);
        return false;
      }
      if (!this.searchingVehicleRtoNumber) {
        notifyError(MESSAGES.VEHICLE_RTO_NUMBER_BLANK_ERROR);
        return false;
      }
      const from = moment(this.fromTime);
      const to = moment(this.toTime);
      if (from.isAfter(this.toTime)) {
        notifyError('From time should be less than To time');
        return false;
      }
      // if (from.)
      this.fetchDistanceTravelledReport({
        rtoNumber:  this.searchingVehicleRtoNumber ? this.searchingVehicleRtoNumber.rtoNumber : "",
        fromTime: from.utc(),
        toTime: to.utc(),
      });
    },
    filterChange(e) {
      this.vehicleSearchFilter = e.filter.value ? e.filter.value.toLowerCase() : "";
    }
  },
  computed: {
    ...mapState({
      // driverList: (state) => state.drivers,
      EmployeeErrors: (state) => state.EmployeeErrors,
    }),
    ...mapGetters(["vendors", "getDistanceTravelledReport", "getVehicles", "getLoaderStatus"]),
    getFilteredVehicles() {
      return this.getVehicles.filter((v) => v.rtoNumber.toLowerCase().includes(this.vehicleSearchFilter))
    },
    total() {
      return this.distanceTravelReport ? this.distanceTravelReport.length : 0;
    },
    items: {
      get: function () {
        let Distance = 0;
        this.distanceTravelReport.forEach((e) => {  Distance += e.Distance  });
        $("#total-distance").text(Distance);
        return orderBy(
          this.distanceTravelReport.slice(this.skip, this.take + this.skip),
          this.sort
        );
      },
    },
    distanceTravelReport() {
      console.log("#Distance Report ", this.getDistanceTravelledReport);
      return this.getDistanceTravelledReport.filter(
        (data) =>
          JSON.stringify(data)
            .toLowerCase()
            .indexOf(this.searchText.toLowerCase()) !== -1
      );
    },
    //    getVehicles () {
    //      return this.$store.getters['getVehicles'];
    //    }
  },
  // created: function () {
  //   this.getDataOnload();
  // },
  mounted() {
    this.getDataOnload();
    $('.k-grid-container').after(`
    <div style="border-top:1px solid #afafaf; font-size: 14px">
      <div class="float-right">
        <span style="margin-right:60px">Total</span> 
        <div style="display:inline-block; width: 100px"> 
          <span id="total-distance">0</span>
          <span> Km</span> 
        </div>
      </div>
    </div>`);
  },
  created: function () {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type == "setSeclectedFacility") {
        // this.loadVendor();
        // this.getDataOnload();
      }
    });
  },
  beforeDestroy() {
    this.setLoaderStatus(false);
    this.unsubscribe();
  },
  beforeMount() {
    const eListColumns = JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_KEYS.DRIVER_MANAGEMENT)
    );
    if (!eListColumns) {
      this.filteredColumns = this.columns;
    } else {
      let items = [];
      this.columns.map((col, i) => {
        const obj = eListColumns.find((c) => c.field === col.field);
        // Ignoring last column
        if (i < this.columns.length - 1)
          if (obj) {
            items.push({
              ...col,
              hidden: obj.hidden,
              checked: obj.checked,
            });
          } else {
            items.push({ ...col });
          }
      });
      // adding ignored last column
      items.push(this.columns[this.columns.length - 1]);
      this.filteredColumns = items;
    }
  },
};
</script>

<style >
.date_pik_mbl{width: 100% !important;}
.search_mobile{width: 15% !important; border-radius: 5px;}
@media only screen and (max-width: 768px){
.mobile_side_dc{display: flex; overflow: auto;}
.date_pik_mbl{width: 150px !important;}
.search_mobile{width: 40% !important;}
.driver_header_mobile{flex-direction: row !important; padding: 10px 10px 10px 10px;}
.page-header .title-text {font-size: 12px;}  
}

</style>